<template>
  <div class="app-container">
    <div class="box-card">
      <div class="content-title"><span class="title-icon"></span><span class="title-details">基本信息</span></div>
      <div slot="content">
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :showBtn="false"
        >
        </dynamic-form>
      </div>
      <folded-panel infoName="里程碑计划">
        <div slot="content">
          <edit-data-table
            :head="milestonePlan"
            :showAdd="showAdd"
            :editable="true"
            :config="{ trigger: 'click', mode: 'cell',autoClearActive:false }"
            :data.sync="tableData"
            height=""
          >
            <template #bsMilestoneNode="{row}">
              <span>{{row.bsMilestoneNode? row.bsMilestoneNode.name:''}}</span>
            </template>
            <template #bsMilestoneNodeEdit="{row}">
              <data-box
                hostUrl="/bsMilestoneNode"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.bsMilestoneNode"
                @confirm="(val) => {row.milestoneNode = val.id}"
              ></data-box>
            </template>
            <template #bsProjectNode="{row}">
              <span>{{row.bsProjectNode? row.bsProjectNode.name:''}}</span>
            </template>
            <template #bsProjectNodeEdit="{row}">
              <data-box
                hostUrl="/bsProjectNode"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.bsProjectNode"
                @confirm="(val) => {row.projectNode = val.id}"
              ></data-box>
            </template>
            <template #bsKeyOuts="{row}">
              <span>{{row.bsKeyOuts? row.bsKeyOuts.name:''}}</span>
            </template>
            <template #bsKeyOutsEdit="{row}">
              <data-box
                hostUrl="/bsKeyOuts"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.bsKeyOuts"
                @confirm="(val) => {row.keyOutput = val.id}"
              ></data-box>
            </template>
            <template #toolbar="{$index}">
              <el-button
                icon="el-icon-delete"
                type="text"
                size="mini"
                @click="delMilestonePlan($index)"
              ></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="奖金分配方案">
        <div slot="content">
          <edit-data-table
            :showAdd="showAdd"
            :head="rewardDistribution"
            :editable="true"
            :config="{ trigger: 'click', mode: 'cell',autoClearActive:false }"
            :data.sync="tableData1"
            height=""
          >
            <template #person="{row}">
              <span>{{row.person? row.person.name:''}}</span>
            </template>
            <template #personEdit="{row}">
              <data-box
                hostUrl="/bs-person/getList"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.person"
                @confirm="(val) => {row.staff = val.id}"
              ></data-box>
            </template>
            <template #projectRoles="{row}">
              <span>{{row.projectRoles? row.projectRoles.name:''}}</span>
            </template>
            <template #projectRolesEdit="{row}">
              <data-box
                hostUrl="/bsProjectRoles"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="dataBoxHead"
                :multiple="false"
                v-model="row.projectRoles"
                @confirm="(val) => {row.projectRole = val.id}"
              ></data-box>
            </template>
            <template #toolbar="{$index}">
              <el-button
                icon="el-icon-delete"
                type="text"
                size="mini"
                @click="delRewardDistribution($index)"
              ></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="项目奖金">
        <div slot="content">
          <edit-data-table
            :showAdd="showAdd"
            :head="projectFunds"
            :editable="true"
            :config="{ trigger: 'click', mode: 'cell' }"
            :data.sync="tableData2"
            height=""
          >
            <template #toolbar="{$index}">
              <el-button
                icon="el-icon-delete"
                type="text"
                size="mini"
                @click="delProjectFunds($index)"
              ></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <div class="button">
        <el-button
          class="btn-submit"
          @click="save(1)"
        >保存</el-button>
        <el-button
          class="btn-submit"
          @click="submit(2)"
        >提交</el-button>
        <el-button
          class="btn-cancel"
          @click="cancel"
        >取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/dynamic-form";
import "@/components/EditDataTable";
import DataBox from "@/components/dynamic-form/dynamic-data-box";
import {
  saveOrModifyProjectAdjustment,
  findProjectAdjustmentById,
  removeBonus,
  removeBonusPlan,
  removeMilestone
} from "@/api/bill/ProjectAdjustment";
import { parseTime } from "@/utils";

export default {
  name: "ContractForm",
  components: { FoldedPanel, DataBox },
  data() {
    return {
      id: "",
      dataBoxHead: [
        { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "备注", property: "code" }
      ],
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            label: "单据编号",
            value: "",
            span: 8
          },
          {
            type: "input",
            disabled: true,
            key: "projectNumber",
            label: "项目号",
            value: "",
            span: 8
          },
          {
            type: "input",
            disabled: true,
            key: "name",
            label: "项目名",
            value: "",
            span: 8
          },
          {
            type: "input",
            disabled: true,
            key: "projectTypeOri",
            label: "原立项类型",
            value: "",
            span: 8
          },
          {
            type: "select",
            disabled: false,
            key: "projectTypeNow",
            label: "现立项类型",
            value: "",
            span: 8
          },
          {
            type: "input",
            disabled: true,
            key: "sourceNumber",
            label: "来源单据号",
            value: "",
            span: 8
          },
          {
            type: "input",
            disabled: true,
            key: "operatorOriName",
            label: "原经营人",
            value: "",
            span: 8
          },
          {
            label: "现经营人",
            key: "operatorNow",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "number",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            type: "input",
            disabled: true,
            key: "projectManagerNowName",
            label: "原项目负责人",
            value: "",
            span: 8
          },
          {
            label: "现项目负责人",
            key: "projectManagerOri",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bs-person/getList",
            tableColumn: [
              {
                property: "number",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            type: "number",
            key: "costForecastOri",
            disabled: true,
            label: "原人工成本预算",
            value: "",
            placeholder: "请输入金额",
            span: 8
          },
          {
            type: "number",
            key: "costBalance",
            disabled: true,
            label: "人工成本结余",
            value: "",
            placeholder: "请输入金额",
            span: 8
          },
          {
            type: "number",
            key: "costForecastNow",
            label: "现人工成本预算",
            value: "",
            placeholder: "请输入金额",
            span: 8
          },
          {
            type: "number",
            key: "budgetOri",
            disabled: true,
            label: "原费用预算",
            value: "",
            placeholder: "请输入金额",
            span: 8
          },
          {
            type: "number",
            key: "budgetBalance",
            disabled: true,
            label: "费用预算结余",
            value: "",
            placeholder: "请输入金额",
            span: 8
          },
          {
            type: "number",
            key: "budgetNow",
            label: "现费用预算",
            value: "",
            placeholder: "请输入金额",
            span: 8
          },
          {
            type: "input",
            disabled: true,
            key: "planCloseTimeOri",
            label: "原计划结项日期",
            value: "",
            span: 8
          },
          {
            span: 8,
            key: "planCloseTimeNow",
            value: "",
            placeholder: "请选择",
            type: "date",
            label: "现计划结项日期",
            valueFormat: "yyyy-MM-dd"
          },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入标题",
            span: 16
          }
        ]
      },
      form: {},
      showAdd: true,
      milestonePlan: [
        {
          label: "里程碑节点编号",
          prop: "code",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "里程碑节点",
          prop: "bsMilestoneNode",
          editRender: { type: "default" }
        },
        {
          label: "对应项目节点",
          prop: "bsProjectNode",
          editRender: { type: "default" }
        },
        {
          label: "原最晚完成时间",
          prop: "latestFinishTimeOri",
          formatter: this.formatter,
          editRender: {
            name: "ElDatePicker",
            props: { type: "date", valueFormat: "timestamp" }
          }
        },
        {
          label: "现最晚完成时间",
          prop: "latestFinishTimeNow",
          formatter: this.formatter,
          editRender: {
            name: "ElDatePicker",
            props: { type: "date", valueFormat: "timestamp" }
          }
        },
        {
          label: "关键输出物",
          prop: "bsKeyOuts",
          editRender: { type: "default" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      rewardDistribution: [
        {
          label: "项目角色",
          prop: "projectRoles",
          editRender: { type: "default" }
        },
        {
          label: "人员",
          prop: "person",
          editRender: { type: "default" }
        },
        {
          label: "分配比例",
          prop: "ratio",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "发放条件",
          prop: "conditions",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      projectFunds: [
        {
          label: "原条件",
          prop: "conditionsOri"
        },
        {
          label: "现条件",
          prop: "conditionsNow"
        },
        {
          label: "原奖金额",
          prop: "prizeAmountOri"
        },
        {
          label: "现奖金额",
          prop: "prizeAmountNow"
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableData: [],
      tableData1: [],
      tableData2: []
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      findProjectAdjustmentById(this.id).then(result => {
        console.log(result);
        const form = result.data.projectAdjustment;
        form.operatorNow = { id: form.operatorNow, name: form.operatorNowName };
        form.projectManagerOri = {
          id: form.projectManagerOri,
          name: form.projectManagerOriName
        };
        this.form = form;
        this.tableData = result.data.adjustMilestoneList;
        this.tableData1 = result.data.adjustBonusPlans;
        this.tableData2 = result.data.adjustBonuses;
      });
    }
  },
  methods: {
    formatter(val) {
      if (val) {
        const date = new Date(val);
        return parseTime(date, "{y}-{m}-{d}");
      }
    },
    delMilestonePlan(index) {
      if (this.tableData[index].id) {
        removeMilestone(this.tableData[index].id);
        this.tableData.splice(index, 1);
      } else {
        this.tableData.splice(index, 1);
      }
    },
    delRewardDistribution(index) {
      if (this.tableData1[index].id) {
        removeBonusPlan(this.tableData1[index].id);
        this.tableData1.splice(index, 1);
      } else {
        this.tableData1.splice(index, 1);
      }
    },
    delProjectFunds(index) {
      if (this.tableData2[index].id) {
        removeBonus(this.tableData2[index].id);
        this.tableData2.splice(index, 1);
      } else {
        this.tableData2.splice(index, 1);
      }
    },
    save(status) { // 保存
      if (this.form.operatorNow) {
        this.form.operatorNowName = this.form.operatorNow.name;
        this.form.operatorNow = this.form.operatorNow.id;
      }
      if (this.form.projectManagerOri) {
        this.form.projectManagerOriName = this.form.projectManagerOri.name;
        this.form.projectManagerOri = this.form.projectManagerOri.id;
      }
       this.form.billState = status
      const projectAdjustment = this.form;
      projectAdjustment.operatorOriName = projectAdjustment.operatorNow.id;
      projectAdjustment.projectManagerNowName = projectAdjustment.projectManagerOri.id;
      const obj = {}
      obj.projectAdjustment = projectAdjustment
      obj.adjustMilestoneList = this.tableData
      obj.adjustBonusPlans = this.tableData1
      obj.adjustBonuses = this.tableData2
     this.update(obj)
    },
    submit(status) { // 提交
      if (this.form.operatorNow) {
        this.form.operatorNowName = this.form.operatorNow.name;
        this.form.operatorNow = this.form.operatorNow.id;
      }
      if (this.form.projectManagerOri) {
        this.form.projectManagerOriName = this.form.projectManagerOri.name;
        this.form.projectManagerOri = this.form.projectManagerOri.id;
      }
       this.form.billState = status
      const projectAdjustment = this.form;
      projectAdjustment.operatorOriName = projectAdjustment.operatorNow.id;
      projectAdjustment.projectManagerNowName = projectAdjustment.projectManagerOri.id;
      const obj = {}
      obj.projectAdjustment = projectAdjustment
      obj.adjustMilestoneList = this.tableData
      obj.adjustBonusPlans = this.tableData1
      obj.adjustBonuses = this.tableData2
      this.update(obj)
    },
    update(data) {
      saveOrModifyProjectAdjustment(data).then(res => {
        this.$notify({
          title: "保存成功",
          type: "success",
          duration: 2500
        });
        this.$router.go(-1);
      });
    },
    cancel() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container {
  .box-card {
    background-color: #fff;
    padding: 20px 30px 20px 30px;
    border-radius: 10px;

    .content-title {
      height: 40px;
      background-color: #e7eff6;
      padding-left: 20px;
      overflow: hidden;

      .title-icon {
        display: inline-block;
        margin-top: 8px;
        width: 4px;
        height: 24px;
        background-color: #1369a8;
        margin-right: 14px;
      }

      .title-details {
        overflow: hidden;
        line-height: 20px;
        display: inline-block;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        font-family: SourceHanSansSC-regular;
      }
    }

    .button {
      padding-top: 20px;
      text-align: right;

      .btn-submit {
        width: 80px;
        height: 38px;
        background: #1369a8;
        color: white;
      }

      .btn-cancel {
        width: 80px;
        height: 38px;
        background: #fff;
      }
    }
  }
}
</style>
